let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7Hoje")).then(() => parcelRequire('2lDN4'));